import type { UnauthApi } from '@/api';

type CategoryGroupProductsOptions = NonNullable<
  Parameters<
    (typeof UnauthApi)['get:/wello/v2/allows/home-love/main/category-group-gift-products']
  >[0]
>;

export type GiftCategoryGroupCode =
  CategoryGroupProductsOptions['query']['giftCategoryGroupType'];

export const ALL_CATEGORY_GROUP_CODE: GiftCategoryGroupCode = 'ALL';

//* 응답 groupCode 가 스웨거상 string 이라 URL 값을 걸러낼 런타임 목록이 필요하다 — Record 라 코드가 늘면 컴파일이 막는다
export const GIFT_CATEGORY_GROUP_CODE = {
  ALL: 'ALL',
  GRAIN: 'GRAIN',
  FRUIT: 'FRUIT',
  MUSHROOM_VEGETABLE: 'MUSHROOM_VEGETABLE',
  LIVESTOCK: 'LIVESTOCK',
  FISH: 'FISH',
  SEAFOOD: 'SEAFOOD',
  PROCESSED_SEAFOOD: 'PROCESSED_SEAFOOD',
  FOREST: 'FOREST',
  OIL_SEASONING: 'OIL_SEASONING',
  RICE_CAKE_SNACK: 'RICE_CAKE_SNACK',
  KIMCHI_SIDE_DISH: 'KIMCHI_SIDE_DISH',
  PROCESSED_FOOD: 'PROCESSED_FOOD',
  BEVERAGE: 'BEVERAGE',
  HEALTH_FOOD: 'HEALTH_FOOD',
  CONVENIENCE_FOOD: 'CONVENIENCE_FOOD',
  TOUR_SERVICE: 'TOUR_SERVICE',
  LIVING: 'LIVING',
  GIFT_CERTIFICATE: 'GIFT_CERTIFICATE',
} as const satisfies Record<GiftCategoryGroupCode, GiftCategoryGroupCode>;

export const GIFT_PAGE_SIZE = 12;

export const MOBILE_GIFT_COUNT = 6;

export const GIFT_PRODUCT_SORT_TYPE = {
  RECOMMEND: 'RECOMMEND',
  LATEST: 'LATEST',
  POPULAR: 'POPULAR',
  REVIEW_COUNT: 'REVIEW_COUNT',
  RATING: 'RATING',
} as const;

export type GiftProductSortType =
  (typeof GIFT_PRODUCT_SORT_TYPE)[keyof typeof GIFT_PRODUCT_SORT_TYPE];

const GIFT_PRODUCT_SORT_TYPE_LABEL = {
  [GIFT_PRODUCT_SORT_TYPE.RECOMMEND]: '추천순',
  [GIFT_PRODUCT_SORT_TYPE.LATEST]: '최근등록순',
  [GIFT_PRODUCT_SORT_TYPE.POPULAR]: '인기순',
  [GIFT_PRODUCT_SORT_TYPE.REVIEW_COUNT]: '후기 많은순',
  [GIFT_PRODUCT_SORT_TYPE.RATING]: '평점 높은순',
} as const;

export const SORT_TYPE_OPTIONS = Object.entries(GIFT_PRODUCT_SORT_TYPE).map(
  ([key, value]) => ({
    label:
      GIFT_PRODUCT_SORT_TYPE_LABEL[key as keyof typeof GIFT_PRODUCT_SORT_TYPE],
    value,
  }),
);
